export const falseValueEqualityFn = (): boolean => false;
